import React, { useEffect } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function PaymentGarageSuccess() {
    const navigate = useNavigate();

    const addPayment = localStorage.getItem('add_payment');
    const orderId = localStorage.getItem('orderId');

    let addPaymentObject = null;
    let orderIdObject = null;

    if (addPayment) {
        try {
            addPaymentObject = JSON.parse(addPayment);
        } catch (e) {
            console.error('Error parsing addPayment:', e);
        }
    }

    if (orderId) {
        try {
            orderIdObject = JSON.parse(orderId);
        } catch (e) {
            console.error('Error parsing orderId:', e);
        }
    }

    useEffect(() => {
        if (orderIdObject) {
            console.log('orderIdObject', orderIdObject);
            axios.post(`${process.env.REACT_APP_API_URL}`, { action: "UpdateGaragePaymentStatus", order_id: orderIdObject })
                .then((response) => {
                    console.log('response', response);
                })
                .catch((error) => {
                    console.error('Error updating payment status:', error);
                });
        } else {
            console.error('No valid orderIdObject found');
        }
    }, [orderIdObject]);

    return (
        <section className="sale-items-sec sec-padding">
            <div className="container-fluid">
                <div className="sec-title text-center">
                    <div className="cicle p-2 mb-4">
                        <i className="fa fa-check text-primary" style={{color: '#ffffff', fontSize: '50px'}}></i>
                    </div>
                    <br />
                    <h3>Payment Success</h3>
                </div>
                <p className="text-center">Congratulations! Your payment has been successfully processed. Thank you for your transaction!</p>
                <div className="sales-items">
                    <div>
                        <div className="text-center m-2">
                            <a href="/view-contract" className="btn btn-outline-primary">Manage Contracts</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
